module.exports = __webpack_public_path__ + "img/img3.914ff455.jpg";